export default __webpack_public_path__ + "static/media/blur4.98803100.png";